import React from 'react'
import Header from '../components/Header'
import { History } from '../components/History'

export default function Historypage() {
  return (
      <>
     <Header/>
      <History/>
      
      </>
  )
}
